import {ChangeDetectionStrategy, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokService} from '@core/services/storyblok.service';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {StoryblokBaseComponent} from '../storyblok-base.component';

@Component({
  selector: 'app-storyblok-text',
  templateUrl: './storyblok-text.component.html',
  styleUrls: ['./storyblok-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective]
})
export class StoryblokTextComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokService = inject(StoryblokService);
  private storyblokStylingService = inject(StoryblokStylingService);


  readonly body = input<any>();
  readonly _editable = input<any>();
  readonly textSize = input<string>();
  readonly transparentBackground = input<boolean>();
  readonly general_styling = input<any>();

  @HostBinding('class') class: any;

  get getCols() {
    return this.storyblokService.getCols(this.col());
  }

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12}, this.col());
    this.class.push('text-' + this.textSize());
  }

}
